exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".QuickSearch_QuickSearch_3hGAB {\n    padding: 10px 10px 10px 0px;\n}", ""]);

// Exports
exports.locals = {
	"QuickSearch": "QuickSearch_QuickSearch_3hGAB"
};